import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'nominas/seguro-issste-registro-cuenta-contable-pasivo-empleado/';

/**
 * GET Cuentas Contables Pasivo Empleado ISSSTE
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesPasivoEmpleadoISSSTE = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuenta Contable Pasivo Empleado ISSSTE
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContablePasivoEmpleadoISSSTE = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Cuenta Contable Pasivo Empleado ISSSTE
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContablePasivoEmpleadoISSSTE = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta Contable Pasivo Empleado ISSSTE
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContablePasivoEmpleadoISSSTE = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta Contable Pasivo Empleado ISSSTE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCuentaContablePasivoEmpleadoISSSTE = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
